import React, { FormEvent, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const Evaluation = () => {
    const navigate = useNavigate();
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("id");
    const { moduleId } = useParams<{ moduleId: string }>();

    const [isLoading, setIsLoading] = useState(true);
    const [evaluations, setEvaluation] = useState<any>(null);
    const [answers, setAnswers] = useState<{ [questionId: string]: string }>({});

    const handleSubmit = async (e: FormEvent<HTMLFormElement> | null = null) => {
        if (e) e.preventDefault();

        const formattedAnswers = Object.entries(answers).map(([questionId, selectedOption]) => ({
            questionId,
            selectedOption,
        }));

        try {
            const response = await fetch(
                `https://has-backend-c48d669d897f.herokuapp.com/student/evaluation/${userId}/${moduleId}/submit`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({ examAnswers: formattedAnswers }),
                }
            );

            const result = await response.json();
            navigate(`/students/${userId}/modules/${moduleId}`);
            console.log("Evaluación enviada con éxito:", result);
        } catch (error) {
            console.error("Error al enviar evaluación:", error);
        }
    };

    useEffect(() => {
        fetch(`https://has-backend-c48d669d897f.herokuapp.com/student/modules/${moduleId}/evaluation`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                if (!response.ok) throw new Error(`Error HTTP! Estado: ${response.status}`);
                return response.json();
            })
            .then((data) => {
                setEvaluation(data);
                setIsLoading(false);
            })
            .catch((error) => {
                console.error("Error al cargar detalles del módulo:", error);
                setIsLoading(false);
            });
    }, [moduleId, token]);

    const handleOptionClick = (questionId: string, selected: string) => {
        setAnswers((prev) => ({
            ...prev,
            [questionId]: selected,
        }));
    };

    return (
        <div className="px-4 sm:px-16 py-6">
            <button
                className="text-sm underline text-blue-600 mb-4"
                onClick={() => navigate(`/students/${userId}/modules/${moduleId}`)}
            >
                ← Regresar al módulo
            </button>
            <div className="flex flex-col items-center w-full">
                <h2 className="font-playfair font-bold text-3xl sm:text-4xl mt-4 mb-2 text-center">
                    Evaluación de módulo
                </h2>
                <p className="font-sourceSans text-center text-sm sm:text-base mb-6">
                    Contesta con sinceridad y concentración. Una vez iniciada, no puedes salir de la pestaña. ¡Mucho éxito!
                </p>

                {isLoading ? (
                    <p>Cargando evaluación...</p>
                ) : evaluations ? (
                    <form
                        onSubmit={handleSubmit}
                        className="bg-[#f8f8f8] w-full sm:w-[85%] rounded-md shadow-md p-4 sm:p-6 space-y-6"
                    >
                        {evaluations.evaluation.map((question: any, index: number) => (
                            <div key={question._id} className="mb-4">
                                <p className="font-semibold mb-2">
                                    {index + 1}. {question.questionText}
                                </p>
                                {question.imageUrl && (
                                    <img
                                        src={question.imageUrl}
                                        alt={`Pregunta ${index + 1}`}
                                        className="w-full max-w-md mx-auto mb-4 rounded-md shadow"
                                    />
                                )}
                                <div className="mt-2 space-y-2">
                                    {question.options.map((option: any, idx: number) => {
                                        const isSelected = answers[question._id] === (option.text || option.imageUrl);
                                        const displayValue = option.text || option.imageUrl;

                                        return (
                                            <button
                                                type="button"
                                                key={idx}
                                                onClick={() => handleOptionClick(question._id, displayValue)}
                                                className={`w-full text-left p-3 rounded-md border flex items-center gap-4 ${
                                                    isSelected
                                                        ? "bg-blue-100 border-blue-500"
                                                        : "bg-white hover:bg-gray-100"
                                                }`}
                                            >
                                                {option.imageUrl && (
                                                    <img
                                                        src={option.imageUrl}
                                                        alt={`Opción ${idx + 1}`}
                                                        className="w-20 h-20 object-contain rounded border"
                                                    />
                                                )}
                                                {option.text && <span className="text-sm sm:text-base">{option.text}</span>}
                                            </button>
                                        );
                                    })}
                                </div>
                            </div>
                        ))}

                        <div className="flex flex-col items-center">
                            <button
                                type="submit"
                                className="bg-[#1c1c2e] text-white font-sourceSans rounded-md shadow-md w-full sm:w-1/3 py-3 mt-6"
                            >
                                Terminar evaluación
                            </button>
                        </div>
                    </form>
                ) : (
                    <p>No se encontró evaluación</p>
                )}
            </div>
        </div>
    );
};

export default Evaluation;

